import { Box, SimpleGrid } from "@chakra-ui/react";

const ParticipantsGridView = ({ renderParticipantType }) => (
  <Box
    p="6px 15px"
    height="100%"
    overflowY="scroll"
    sx={{
      "&::-webkit-scrollbar": {
        display: "none",
      },
    }}
  >
    <SimpleGrid columns="3" spacing="7">
      {renderParticipantType()}
    </SimpleGrid>
  </Box>
);

export default ParticipantsGridView;
